import { Box, styled, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { LocalDishType } from "types/mainTypes";
import { getDiscountPercentage } from "utils/mealListUtils";

const SALE_DISCOUNT_THRESHOLD = 30;

type SaleWrapperProps = {
	dishType: LocalDishType;
	children: ReactNode;
};

export const SaleWrapper = ({ dishType, children }: SaleWrapperProps) => {
	const { t } = useTranslation();
	const discountPercentage = getDiscountPercentage(dishType);

	if (discountPercentage < SALE_DISCOUNT_THRESHOLD) {
		return <>{children}</>;
	}

	return (
		<StyledWrapper>
			<StyledTopBar>
				<StyledLabel variant="mealSub">{t("dishListPage.specialDeal")}</StyledLabel>
				<StyledDiscount variant="mealSub">-{discountPercentage}%</StyledDiscount>
			</StyledTopBar>
			<StyledContent>{children}</StyledContent>
		</StyledWrapper>
	);
};

const SALE_COLOR = "#F05657";

const StyledWrapper = styled(Box)({
	borderRadius: "16px",
	backgroundColor: SALE_COLOR,
	padding: "2px",
});

const StyledTopBar = styled(Box)({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	padding: "8px 20px 8px 16px",
});

const StyledLabel = styled(Typography)({
	color: "#FFFFFF",
	fontWeight: 600,
	lineHeight: "28px",
});

const StyledDiscount = styled(Typography)({
	color: "#FFFFFF",
	fontWeight: 600,
	lineHeight: "28px",
});

const StyledContent = styled(Box)({
	overflow: "hidden",
	backgroundColor: "transparent",
	borderRadius: "14px",
	boxShadow: "0 -4px 16px 0 rgba(0, 0, 0, 0.25), 4px 8px 16px 0 rgba(42, 42, 52, 0.08)",
});
